import React from 'react';
import WName, {WArticle} from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../../ormaybe/OrMaybeLink';
import LRL from '../LongReadLink';
import {E1, E2, TLDR, Qual, Rando, Switcheroo} from '../../common';

// ‘’ … –

// Belief is not 'truth'; truth must *emerge* (not be externaally imposed, cf the FOE).

export const belief = {
  name: "belief",
  alternatives: "believe,believes,believing",
  prelude: <span>
    Sorry, Kierkegaard.
  </span>,
  header: <span>
    Our <i>beliefs</i> do not create ‘truth’.
  </span>,
  outside: <span>
    Especially a <NW>POC</NW>’s (or <NW>POC</NW>’s) <PL>individual</PL> and <i><NW>heterognostic</NW></i> beliefs.
  </span>,
  preview: <div className="long-read-preview">
    <p>It’s got to do, frankly, with the <PL>human standard</PL>’s <AL name="sick.OCD">obsessive</AL> <LRL>notion</LRL> that <NW>APE</NW>.</p>
    <p><i>Belief</i> is not ‘truth’. And truth is not Truth<sup>®</sup> as <i><PL name="arbitrer">imposed</PL></i> by some OutsideOther<sup>™</sup>, cf. the <NW>FOE</NW>. Truth must <i>emerge</i> from something more <PL name="directionality">fundamental</PL>.</p>
  </div>,
  text: <div className="long-read-text">
    <p><QL name="ouroboros">Ouroboric</QL> statements like ‘this statement is false’ (the ‘<AL name="fields.logic.">liar paradox</AL>’) and the more insidious one: ‘<AL>the authoritarian</AL>’ (‘this statement is <i>true</i>’) do not – just being ‘statements’, however you <i><LRL name="substance">represent</LRL></i> them – have a determinite and inherent ‘truth value’.</p>
    <p>They can both be resolved  but it might require <LRL name="shift">completely changing your thinking</LRL>. It might require <PL name="ch.ishmael">Dr Ishmael</PL>.</p>
    <p>[Under construction]</p>
  </div>,
};
